import { useTranslation } from "react-i18next";
import { Card, CardContent } from "../ui/card";
import { Progress } from "../ui/progress";
import { Zap } from "lucide-react";

const CalculationProgress = ({ progress, calculating }) => {
  const { t } = useTranslation();
  if (!calculating) return null;

  return (
    <Card className="border-primary/40 bg-primary/5">
      <CardContent className="p-6">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Zap className="h-5 w-5 text-primary animate-pulse" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground">{t("payrollUi.progress.inProgress")}</h3>
              <p className="text-sm text-muted-foreground">{t("payrollUi.progress.processing")}</p>
            </div>
            <div className="ml-auto">
              <span className="text-2xl font-bold text-primary">{Math.round(progress)}%</span>
            </div>
          </div>
          <div className="space-y-2">
            <Progress value={progress} className="h-3 bg-muted" />
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>{t("payrollUi.progress.analyzeAttendance")}</span>
              <span>{t("payrollUi.progress.calcInProgress")}</span>
              <span>{t("payrollUi.progress.finalization")}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CalculationProgress;
